<template>
  <div class="ku-up">
    <div class="ku-up-tip">正在对 {{ namekey }} 位置上传视频</div>

    <!-- 子目录（片段）：走 COS 临时密钥直传，限制 10MB -->
    <div v-if="kuinfo.parent != 0" class="ku-up-body">
      <el-upload class="upload-demo" drag action="#" multiple :http-request="cos_upload"
        :before-upload="cos_upload_fast" :on-preview="cos_file_list_fc" :on-progress="uploading"
        :file-list="cos_videoFileList" accept=".mp4">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">只能上传 mp4 文件，且不超过 10MB 的视频</div>
      </el-upload>
    </div>

    <!-- 项目根：走服务端 upload.php（敏感 key 由后端下发），限制 100MB -->
    <div v-else class="ku-up-body">
      <el-upload class="upload-demo" drag action="#" multiple :http-request="upload"
        :before-upload="upload_fast" :on-preview="file_list_fc" :on-progress="uploading"
        :file-list="videoFileList" accept=".mp4">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">只能上传 mp4 文件，且不超过 100MB 的视频</div>
      </el-upload>
    </div>
  </div>
</template>

<script>
// 2.0 版上传：接口改走新后端（/ku/upload-token 整段、/ku/cos-sts 片段），
// 上传成功后 $emit('uploaded') 让父组件刷新当前素材列表；不再用 $parent.$parent 深链。
const COS = require('cos-js-sdk-v5')

export default {
  name: 'User2KuUpload',
  props: {
    kuinfo: { type: [Object, Array], default: () => ({}) },
    namekey: { type: String, default: '' }
  },
  data() {
    return {
      videoFileList: [],
      cos_videoFileList: []
    }
  },
  methods: {
    upload_fast(file) {
      const isMp4 = file.type === 'video/mp4'
      const isLt = file.size / 1024 / 1024 < 100
      if (!isMp4) this.$message.error('上传视频文件只能是 mp4 格式!')
      if (!isLt) this.$message.error('上传视频大小不能超过 100MB!')
      return isMp4 && isLt
    },
    cos_upload_fast(file) {
      const isMp4 = file.type === 'video/mp4'
      const isLt = file.size / 1024 / 1024 < 10
      if (!isMp4) this.$message.error('上传视频文件只能是 mp4 格式!')
      if (!isLt) this.$message.error('上传视频大小不能超过 10MB!')
      return isMp4 && isLt
    },
    // 项目根整段上传：先取服务端 upload.php 地址与加密 key，再表单直传
    upload(param) {
      param.status = 'uploading'
      param.percentage = 0
      param.name = param.file.name
      this.videoFileList.push(param)

      const payload = {
        id: this.kuinfo.id,
        parent: this.kuinfo.parent || 0,
        fwq: this.kuinfo.fwq || '',
        filename: param.file.name
      }
      this.$ajax.post('api/v1/users/ku/upload-token', payload).then(res => {
        const body = res.data || {}
        const info = body.data || {}
        if (body.status != 200 || !info.url) {
          param.status = 'failed'
          param.message = body.msg || '上传失败'
          this.$msg.error(body.msg || '获取上传地址失败')
          return
        }
        const fdata = new window.FormData()
        fdata.append('file', param.file)
        fdata.append('key', info.key)
        fdata.append('kuname', this.kuinfo.name)
        this.$ajax_upload.post(info.url, fdata, {
          onUploadProgress: (progressEvent) => {
            param.percentage = Number((progressEvent.loaded / progressEvent.total * 100).toFixed(0))
          }
        }).then(response => {
          if (String(response.data).indexOf('处理插入成功') !== false) {
            param.status = 'success'
            this.$msg.success(param.file.name + ' 上传成功')
            this.$emit('uploaded')
          } else {
            param.status = 'failed'
            param.message = '上传失败'
            this.$msg.error(param.file.name + ' 上传失败')
          }
        }).catch(() => {
          param.status = 'failed'
          param.message = '上传失败'
          this.$msg.error(param.file.name + ' 上传失败')
        })
      }).catch(() => {
        param.status = 'failed'
        param.message = '上传失败'
        this.$msg.error('获取上传地址失败')
      })
    },
    // 子目录片段上传：取 COS 临时密钥后直传（后端同时把素材入库）
    cos_upload(param) {
      param.status = 'uploading'
      param.percentage = 0
      param.name = param.file.name
      this.cos_videoFileList.push(param)

      const dzkey = 'spk/' + this.kuinfo.uid + '/' + this.kuinfo.parent + '/' + this.kuinfo.wz + '/' + param.file.name
      this.$ajax.post('api/v1/users/ku/cos-sts', {
        dzkey: dzkey,
        filename: param.file.name,
        ku: {
          uid: this.kuinfo.uid,
          parent: this.kuinfo.parent,
          name: this.kuinfo.name,
          wz: this.kuinfo.wz
        }
      }).then(res => {
        const body = res.data || {}
        const cred = (body.data || {}).Credentials
        if (body.status != 200 || !cred) {
          param.status = 'failed'
          param.message = body.msg || '上传失败'
          this.$msg.error(body.msg || '获取上传密钥失败')
          return
        }
        const cosf = new COS({
          SecretId: cred.TmpSecretId,
          SecretKey: cred.TmpSecretKey,
          SecurityToken: cred.Token
        })
        cosf.putObject({
          Bucket: 'spk-1301238423',
          Region: 'ap-guangzhou',
          Key: dzkey,
          Body: param.file,
          onProgress: (progressData) => {
            param.percentage = Math.round(progressData.percent * 100)
          }
        }, (err, data) => {
          if (!err && data && data.statusCode == 200) {
            param.status = 'success'
            this.$msg.success(param.file.name + ' 上传成功')
            this.$emit('uploaded')
          } else {
            param.status = 'failed'
            param.message = '上传失败'
            this.$msg.error(param.file.name + ' 上传失败')
          }
        })
      }).catch(() => {
        param.status = 'failed'
        param.message = '上传失败'
        this.$msg.error('获取上传密钥失败')
      })
    },
    file_list_fc(file) {
      console.log(file)
    },
    cos_file_list_fc(file) {
      console.log(file)
    },
    uploading(e) {
      console.log(e)
    }
  }
}
</script>

<style scoped>
.ku-up-tip {
  margin-bottom: 18px;
  color: #64748b;
  font-size: 13px;
}

.ku-up-body {
  text-align: center;
}

.ku-up-body /deep/ .el-upload,
.ku-up-body /deep/ .el-upload-dragger {
  width: 100%;
  box-sizing: border-box;
}

.ku-up-body /deep/ .el-upload-dragger {
  padding: 24px 10px;
}

.ku-up-body /deep/ .el-upload-list__item-name {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/User2/Ku_upload.vue